<template>
  <div>
    <div v-if="loader" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="card-chart">
      <highcharts :options="chartOptions"></highcharts>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  name: 'PercentageBarPanels',

  props: ['dataGraph'],

  data: () => ({
    chartOptions: null,
    loader: true,
    promoters: 0,
    passive: 0,
    detractors: 0,
    userAuth: null,
    charTitle: '',
    chartNoData: '',
    chartSeries: '',
    chartPromoters: '',
    chartPassives: '',
    chartDetrators: '',
    chartMax: 100,
    data: [],
  }),
  watch: {
  },
  computed: {
    ...mapState('dashboard', ['percentilNps']),
    ...mapState('actions', ['myActionId']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('authentication', ['userProfile']),
  },
  methods: {
    ...mapActions('dashboard', ['getMetricValue']),

async getData() {
      const res = await api.get(
        `${process.env.API_ROOT}/metrics-panel/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
              actionId: this.dataGraph.actionId ? this.dataGraph.actionId._id : null,
              ih1:  this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
              metric: this.dataGraph.metric,
              groupId: this.dataGraph.actionGroupId ? this.dataGraph.actionGroupId._id : null,
              indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
              indicatorValue: this.dataGraph.valueIndicator,
              period: this.dataGraph.period,
              _id: this.dataGraph._id,
            },
          },
      );

      this.data = res.data;

      const total =
        this.data.promoters +
        this.data.passive +
        this.data.detractors;

      this.promoters = await parseFloat(
        ((this.data.promoters / total) * 100).toFixed(1),
      );
      this.passive = await parseFloat(
        ((this.data.passive / total) * 100).toFixed(1),
      );
      this.detractors = await parseFloat(
        ((this.data.detractors / total) * 100).toFixed(1),
      );
    },
    handleClick(type) {
      type = type.toLowerCase();

      let customerGroup;

      if (
        this.dataGraph.metric === 'csat-1-5' ||
        this.dataGraph.metric === 'ces-1-5' ||
        this.dataGraph.metric === '5-stars'
      ) {
        if (type === '4-5') {
          customerGroup = 'promoters';
        } else if (type === '3') {
          customerGroup = 'passives';
        } else {
          customerGroup = 'detractors';
        }
      } else if (type.search('promotores') + 1) {
        customerGroup = 'promoters';
      } else if (type.search('neutros') + 1) {
        customerGroup = 'passives';
      } else {
        customerGroup = 'detractors';
      }

      this.$router.push({
        name: 'Respostas',
        query: { profile: customerGroup },
      });
    },
    async renderBars(series) {
      let categories = [];
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        categories = [
          `${this.data.promoters}
            ${this.chartPromoters}`,
          `${this.data.passive}
            ${this.chartPassives}`,
          `${this.data.detractors}
            ${this.chartDetrators}`,
        ];
      } else {
        categories = [
          `${this.chartPromoters}`,
          `${this.chartPassives}`,
          `${this.chartDetrators}`,
        ];
      }

      this.chartOptions = {
        title: {
          text: '',
        },
        chart: {
          type: 'bar',
          height: this.dataGraph.layout.h * 38,
          spacing: [25, 20, 25, 20],
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
          },
        },
        xAxis: {
          categories,
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          max: this.chartMax,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        legend: {
          enabled: false,
        },
        series: [
          {
            name: this.chartSeries,
            colorByPoint: true,
            data: series,
            cursor: 'pointer',
            point: {
              events: {
                click: (e) =>
                  this.userProfile.permissions.answers.menu
                    ? this.handleClick(e.point.category)
                    : '',
              },
            },
          },
        ],
        tooltip: {
          valueSuffix: '%',
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              format: '{y}%',
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595', '#ecdb12', '#d62027'],
      };
    },
    changeLabel() {
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        this.chartNoData = this.$t('reports.horizontalBar.chartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.chartSeries');
        this.chartPromoters = this.$t('reports.promoterLabel');
        this.chartPassives = this.$t('reports.neutralLabel');
        this.chartDetrators = this.$t('reports.detractorLabel');
        this.chartMax = 100;
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        this.chartNoData = this.$t('reports.horizontalBar.cesChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.ceschartSeries');
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.dataGraph.metric === 'csat-1-5') {
        this.charTitle = this.$t('reports.horizontalBar.csatChartTitle');
        this.chartNoData = this.$t('reports.horizontalBar.csatChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.csatchartSeries');
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.myMetric === 'csat-1-5(media)') {
        this.charTitle = this.$t('reports.horizontalBar.csatAverageChartTitle');
        this.chartNoData = this.$t('reports.horizontalBar.csatChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.csatchartSeries');
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.myMetric === 'csat-0-10(media)') {
        this.charTitle = this.$t('reports.horizontalBar.csat0to10AverageChartTitle');
        this.chartNoData = this.$t('reports.horizontalBar.csatChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.csatchartSeries');
        this.chartPromoters = this.$t('reports.promoterLabel');
        this.chartPassives = this.$t('reports.neutralLabel');
        this.chartDetrators = this.$t('reports.detractorLabel');
        this.chartMax = 100;
      } else if (this.dataGraph.metric === '5-stars') {
        this.charTitle = this.$t('reports.horizontalBar.fiveStarsTitle');
        this.chartNoData = this.$t(
          'reports.horizontalBar.fiveStarsChartNoData',
        );
        this.chartSeries = this.$t(
          'reports.horizontalBar.fiveStarschartSeries',
        );
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.dataGraph.metric.indexOf('like-dislike') !== -1) {
        this.charTitle = this.$t('reports.horizontalBar.likeDislikeTitle');
        this.chartNoData = this.$t(
          'reports.horizontalBar.likeDislikeChartNoData',
        );
        this.chartSeries = this.$t(
          'reports.horizontalBar.likeDislikechartSeries',
        );
        this.chartPromoters = '1';
        this.chartPassives = '';
        this.chartDetrators = '0';
        this.chartMax = 100;
      }
    },

    getChartOptions(){
      this.chartOptions = {
        title: {
          text: '',
        },
        chart: {
          type: 'bar',
          height: this.dataGraph.layout.h * 38,
          spacing: [25, 20, 25, 20],
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
          },
        },
      };
    }
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  async mounted() {
    this.loader = true;
    this.changeLabel();
    await this.getData();
    await this.renderBars([
      this.promoters > 0 ? this.promoters : 0,
      this.passive > 0 ? this.passive : 0,
      this.detractors > 0 ? this.detractors : 0,
    ]);

    if (this.promoters === 0 && this.passive === 0 && this.detractors === 0) {
      this.getChartOptions();
      this.loader = false;
    }

    this.loader = false;

  },
  beforeDestroy() {
    EventBus.$off('drawer');
    EventBus.$off('refresh');
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/horizontal-bar/panels/horizontal-bar.vue